<template>
	<div id="tp-footer" :class="styles()">
        <a :href="tpLink" aria-label="touchpoint restaurant innovations platform" target="_blank" rel="noopener">
            <BaseIcon 
                :editStroke="false"
                :classNames="['tp-logo']"
                icon="tpLogo" 
                :isCustom="true" />
        </a>
        <p class="is-size-7">This store runs on Touchpoint Restaurant Innovations platform. <a :href="tpLink" target="_blank" rel="noopener">Learn more</a> | <a :href="tpLink" target="_blank" rel="noopener">Contact us</a></p>
		<div class="version-container"> 
			<span class="version-label">{{ getVersion }}</span>
		</div>
	</div>
</template>

<script>
import EventBus from '@EventBus';

export default {
    data() {
        return {
			tpLink: 'https://www.touchpoint.io',
			sideBar: false,
        }
	},
	computed: {
		getVersion() {
			const appVersion = `${this.$appConstants.version}`;
			return appVersion;
		},
	},
	methods: {
		sideBarActive() {
			this.sideBar = true;
		},
		styles() {
			return {
				'has-text-centered': true,
				'side-bar': this.sideBar,
			}
		},
	},
	created() {
		EventBus.$on('side-bar-active', this.sideBarActive);
	},
	destroyed() {
		EventBus.$off('side-bar-active');
	}
}
</script>

<style lang="scss">
    @import 'globalStyles';

    #tp-footer {
        width: 100%;
        padding: 1.5em 0em 2em 0em;
        margin: auto;
        background-color: $dimGray;
		color: white;
		p {
			padding: 0 2em;
		}
    }

     #tp-footer p a {
		color: white;
		font-weight: bold;
		text-decoration: underline;
     }
    .tp-logo {

        svg:first-of-type {
            max-height: 2rem;
            font-size: 8rem;
            line-height: 10px;
            height: 2rem;
            margin-bottom: 1rem;
        }

        svg > g > svg > g > path:nth-child(3) {
            color: white;
        }
	}
	
	.version-container {
		display: flex;
		flex-direction: row-reverse;
		position: relative;
		top: 20px;

		margin-top: -20px;
		margin-right: 20px;

		.version-label {
			margin-left: 1em;
			margin-top: 1.5em;
	
			font-size: 0.7em;
			font-weight: bold;
	
			color: $touchpointRed;
			background: white;
	
			padding: 0.33em 0.53em;
			border-radius: 4px;
		}
	}
	@include mobile {
		#tp-footer {
			position: relative;
			top: 0;
			left: 0;
			padding: 1.5em 0.5em 2em 0.5em;
			min-height: 180px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/footer/TPFooter.vue